import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["open"];
const _hoisted_2 = { class: "more-box__top" };
const _hoisted_3 = { class: "more-box__title" };
const _hoisted_4 = { class: "more-box__marker" };
const _hoisted_5 = { class: "more-box__main" };
const _hoisted_6 = { class: "filt-box" };
const _hoisted_7 = {
    key: 0,
    class: "filt-box__bottom"
};
const _hoisted_8 = { class: "line line--jcfe" };
const _hoisted_9 = { class: "line__item" };
const _hoisted_10 = ["disabled"];
import Sprite from "../../../components/Sprite.vue";
import { ref, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItemWrapper',
    props: {
        item: { type: Object, required: true },
    },
    emits: ['reset'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const expanded = ref(props.item.expanded);
        watch(() => props.item.expanded, value => {
            if (value && !expanded.value) {
                expanded.value = value;
            }
        });
        function toggle(event) {
            expanded.value = props.item.expanded = event.target.open;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("details", {
                class: "more-box more-box--bg",
                open: expanded.value,
                onToggle: toggle
            }, [
                _createElementVNode("summary", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, [
                        _createTextVNode(_toDisplayString(__props.item.title) + " ", 1 /* TEXT */),
                        _renderSlot(_ctx.$slots, "badge")
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_4, [
                        _createVNode(Sprite, { name: "arrow-down" })
                    ])
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "body"),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (__props.item.active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn--2 btn--m btn--black",
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.$emit('reset')), ["prevent"])),
                                            disabled: !__props.item.active
                                        }, _cache[2] || (_cache[2] = [
                                            _createElementVNode("span", { class: "btn__label" }, "Сбросить выбор", -1 /* HOISTED */)
                                        ]), 8 /* PROPS */, _hoisted_10)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1));
        };
    }
});
